import { GlIcon, GlLink, GlDisclosureDropdown, GlDisclosureDropdownItem, GlTooltipDirective, GlDropdownDivider } from '@gitlab/ui';
import { __ } from '~/locale';
import TooltipOnTruncate from '~/vue_shared/directives/tooltip_on_truncate';
import toast from '~/vue_shared/plugins/global_toast';
import { visitUrl } from '~/lib/utils/url_utility';
import { createBranchMRApiPathHelper } from '~/work_items/utils';
export default {
    name: 'WorkItemDevelopmentBranchItem',
    components: {
        GlIcon,
        GlLink,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlDropdownDivider
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        TooltipOnTruncate
    },
    props: {
        itemContent: {
            type: Object,
            required: true
        },
        canCreateMergeRequest: {
            type: Boolean,
            required: false,
            default: true
        },
        workItemFullPath: {
            type: String,
            required: true
        },
        workItemIid: {
            type: String,
            required: true
        }
    },
    computed: {
        branchName () {
            return this.itemContent?.name;
        },
        branchComparePath () {
            return this.itemContent?.comparePath;
        },
        iconTooltip () {
            return __('Branch');
        }
    },
    methods: {
        copyToClipboard (text, message) {
            toast(message);
            this.closeDropdown();
        },
        closeDropdown () {
            this.$refs.branchMoreActions.close();
        },
        createMergeRequest () {
            const path = createBranchMRApiPathHelper.createMR({
                fullPath: this.workItemFullPath,
                workItemIid: this.workItemIid,
                sourceBranch: this.branchName
            });
            visitUrl(path);
        }
    }
};
